/* Improve later */
import { $vfm } from "vue-final-modal";
const showDialog = (options = {}) => {
  $vfm.show(options);
};

export default showDialog;
